// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map{flex:1 1 auto;height:100%}.map .gm-ui-hover-effect{display:none !important}.map .gm-style-iw-c{border-radius:4px;box-shadow:-1px 1px 5px 0px rgba(0,0,0,.2)}.map .gm-style-iw-t::after{display:none}.map .gm-style-iw-t{bottom:55px !important}.map .infowindow{margin-left:3px}.map .infowindow-title{font-family:var(--font-regular);font-size:14px}", ""]);
// Exports
module.exports = exports;
